import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { api, messageErreur } from "@/lib/api";
import { useRefs, versOptions } from "@/lib/referentiels";
import { TagPastille } from "@/components/fiche/Tags";
import { ChoixListe } from "./ChoixListe";
import { confirmer } from "@/lib/confirmer";

export default function Champs() {
  const refs = useRefs();
  const [champs, setChamps] = useState([]);
  const [tags, setTags] = useState([]);
  const [f, setF] = useState({ libelle: "", cible: "contact", type: "texte", options: "" });
  const [t, setT] = useState({ nom: "", couleur: "#4A78C2" });
  const charger = useCallback(() => { api.get("/champs").then((r) => setChamps(r.data)); api.get("/tags").then((r) => setTags(r.data)); }, []);
  useEffect(() => { charger(); }, [charger]);
  const agir = (p, msg) => p.then(() => { toast.success(msg); charger(); }).catch((e) => toast.error(messageErreur(e)));
  const demander = (texte, fn) => { confirmer(texte).then((ok) => ok && fn()); };

  return (
    <div className="space-y-6">
      <section>
        <h2 className="text-base md:text-lg font-bold mb-3">Champs personnalisés</h2>
        <form className="at-card p-4 grid sm:grid-cols-2 gap-2" data-testid="custom-field-form"
          onSubmit={(e) => { e.preventDefault(); agir(api.post("/champs", { ...f, options: f.options.split(",") }), "Champ ajouté."); setF({ ...f, libelle: "", options: "" }); }}>
          <input required value={f.libelle} onChange={(e) => setF({ ...f, libelle: e.target.value })} placeholder="Libellé du champ" className="at-input sm:col-span-2" data-testid="custom-field-label" />
          <ChoixListe label="Ajouté aux" valeur={f.cible} onChange={(v) => setF({ ...f, cible: v })} options={[{ code: "contact", label: "Contacts" }, { code: "fiche", label: "Opportunités" }]} testId="custom-field-target" />
          <ChoixListe label="Type" valeur={f.type} onChange={(v) => setF({ ...f, type: v })} options={versOptions(refs?.types_champ)} testId="custom-field-type" />
          {f.type === "liste" && <input value={f.options} onChange={(e) => setF({ ...f, options: e.target.value })} placeholder="Options séparées par des virgules" className="at-input sm:col-span-2" data-testid="custom-field-options" />}
          <button type="submit" className="at-btn at-btn-primary sm:col-span-2" data-testid="custom-field-submit">Ajouter le champ</button>
        </form>
        <div className="space-y-2 mt-3" data-testid="custom-fields-list">
          {champs.map((c) => (
            <div key={c.id} className="at-fiche p-4 flex items-center justify-between gap-3" data-testid={`custom-field-${c.id}`}>
              <div className="min-w-0"><p className="font-bold truncate">{c.libelle}</p><p className="text-sm at-muted">{c.cible === "contact" ? "Contacts" : "Opportunités"} · {refs?.types_champ?.[c.type]}{c.options.length ? ` (${c.options.join(", ")})` : ""}</p></div>
              <button type="button" className="at-icon-btn" aria-label="Retirer" onClick={() => demander(`Retirer le champ « ${c.libelle} » ? Les valeurs déjà saisies sont conservées.`, () => agir(api.delete(`/champs/${c.id}`), "Champ retiré."))} data-testid={`custom-field-delete-${c.id}`}><Trash2 size={17} /></button>
            </div>
          ))}
        </div>
      </section>
      <section>
        <h2 className="text-base md:text-lg font-bold mb-3">Tags</h2>
        <form className="at-card p-4 flex gap-2" onSubmit={(e) => { e.preventDefault(); agir(api.post("/tags", t), "Tag créé."); setT({ ...t, nom: "" }); }} data-testid="tag-form">
          <input required value={t.nom} onChange={(e) => setT({ ...t, nom: e.target.value })} placeholder="Nom du tag" className="at-input" data-testid="tag-name-input" />
          <input type="color" value={t.couleur} onChange={(e) => setT({ ...t, couleur: e.target.value })} className="w-11 h-11 shrink-0 border-0 bg-transparent" aria-label="Couleur" />
          <button type="submit" className="at-btn at-btn-primary shrink-0" data-testid="tag-submit">Ajouter</button>
        </form>
        <div className="flex flex-wrap gap-2 mt-3" data-testid="tags-list">
          {tags.map((tg) => (
            <span key={tg.id} className="inline-flex items-center"><TagPastille tag={tg} />
              <button type="button" className="at-icon-btn" aria-label={`Retirer ${tg.nom}`} onClick={() => demander(`Retirer le tag « ${tg.nom} » ?`, () => agir(api.delete(`/tags/${tg.id}`), "Tag retiré."))} data-testid={`tag-delete-${tg.id}`}><Trash2 size={14} /></button></span>
          ))}
        </div>
      </section>
    </div>
  );
}
